import { BaseApi } from './base.api.js';
import { teamAssociationApiMethods } from './team-association.mixin.js';

export class BcpApi extends BaseApi {
    constructor(client) {
        super(client, '/bcp');
        Object.assign(this, teamAssociationApiMethods(client, this.basePath));
    }

    async getStats() {
        const response = await this.client.get(`${this.basePath}/stats`);
        return response.data;
    }

    // Initial Response relationship
    async getRelatedInitialResponse(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/initial-response`, { params });
        return response.data;
    }

    async addInitialResponseSteps(id, stepIds) {
        const response = await this.client.post(`${this.basePath}/${id}/initial-response`, { stepIds });
        return response.data;
    }

    async removeInitialResponseStep(id, stepId) {
        const response = await this.client.delete(`${this.basePath}/${id}/initial-response/${stepId}`);
        return response.data;
    }

    // Documents relationship
    async getRelatedDocuments(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/documents`, { params });
        return response.data;
    }

    async addDocuments(id, documentIds) {
        const response = await this.client.post(`${this.basePath}/${id}/documents`, { documentIds });
        return response.data;
    }

    async removeDocument(id, documentId) {
        const response = await this.client.delete(`${this.basePath}/${id}/documents/${documentId}`);
        return response.data;
    }

    // Process relationship (In Scope)
    async getRelatedProcesses(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/processes`, { params });
        return response.data;
    }

    async addProcesses(id, processIds) {
        const response = await this.client.post(`${this.basePath}/${id}/processes`, { processIds });
        return response.data;
    }

    async removeProcess(id, processId) {
        const response = await this.client.delete(`${this.basePath}/${id}/processes/${processId}`);
        return response.data;
    }

    // Asset relationship (In Scope)
    async getRelatedAssets(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/assets`, { params });
        return response.data;
    }

    async addAssets(id, assetIds) {
        const response = await this.client.post(`${this.basePath}/${id}/assets`, { assetIds });
        return response.data;
    }

    async removeAsset(id, assetId) {
        const response = await this.client.delete(`${this.basePath}/${id}/assets/${assetId}`);
        return response.data;
    }

    // Vendor relationship (In Scope)
    async getRelatedVendors(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/vendors`, { params });
        return response.data;
    }

    async addVendors(id, vendorIds) {
        const response = await this.client.post(`${this.basePath}/${id}/vendors`, { vendorIds });
        return response.data;
    }

    async removeVendor(id, vendorId) {
        const response = await this.client.delete(`${this.basePath}/${id}/vendors/${vendorId}`);
        return response.data;
    }

    // Communication relationship
    async getRelatedCommunications(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/communications`, { params });
        return response.data;
    }

    async addCommunications(id, communicationIds) {
        const response = await this.client.post(`${this.basePath}/${id}/communications`, { communicationIds });
        return response.data;
    }

    async removeCommunication(id, communicationId) {
        const response = await this.client.delete(`${this.basePath}/${id}/communications/${communicationId}`);
        return response.data;
    }

    // Communication Plan relationship
    async getRelatedCommunicationPlans(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/communication-plans`, { params });
        return response.data;
    }

    async addCommunicationPlans(id, planIds) {
        const response = await this.client.post(`${this.basePath}/${id}/communication-plans`, { planIds });
        return response.data;
    }

    async removeCommunicationPlan(id, planId) {
        const response = await this.client.delete(`${this.basePath}/${id}/communication-plans/${planId}`);
        return response.data;
    }

    // Locations relationship
    async getRelatedLocations(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/locations`, { params });
        return response.data;
    }

    async addLocations(id, locations) {
        const response = await this.client.post(`${this.basePath}/${id}/locations`, { locations });
        return response.data;
    }

    async updateLocation(id, locationId, data) {
        const response = await this.client.put(`${this.basePath}/${id}/locations/${locationId}`, data);
        return response.data;
    }

    async removeLocation(id, locationId) {
        const response = await this.client.delete(`${this.basePath}/${id}/locations/${locationId}`);
        return response.data;
    }

    // Exercises relationship
    async getRelatedExercises(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/exercises`, { params });
        return response.data;
    }

    async addExercises(id, exerciseIds) {
        const response = await this.client.post(`${this.basePath}/${id}/exercises`, { exerciseIds });
        return response.data;
    }

    async removeExercise(id, exerciseId) {
        const response = await this.client.delete(`${this.basePath}/${id}/exercises/${exerciseId}`);
        return response.data;
    }

    async getRelatedBias(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/bias`, { params });
        return response.data;
    }

    async addBias(id, biaIds) {
        const response = await this.client.post(`${this.basePath}/${id}/bias`, { biaIds });
        return response.data;
    }

    async removeBia(id, biaId) {
        const response = await this.client.delete(`${this.basePath}/${id}/bias/${biaId}`);
        return response.data;
    }

    async getPartyTemplate(params = {}) {
        const response = await this.client.get(`${this.basePath}/party-template`, { params });
        return response.data;
    }

    async getParty(id) {
        const response = await this.client.get(`${this.basePath}/${id}/party`);
        return response.data;
    }

    async syncParty(id, body) {
        const response = await this.client.put(`${this.basePath}/${id}/party`, body);
        return response.data;
    }

    async submit(id) {
        const response = await this.client.post(`${this.basePath}/${id}/submit`);
        return response.data;
    }
}
